import create from 'zustand';
import { produce } from 'immer';
import { GlobalModalType } from '../types';
import {
  GlobalModalPropsByType,
  GlobalModalsKeys,
  GlobalModalsProps,
} from '../types/globalModal';

interface State {
  activeModal?: GlobalModalType;
  modalProps: Partial<Record<GlobalModalsKeys, GlobalModalsProps>>;
}

interface Actions {
  setActiveModal<T extends GlobalModalsKeys>(
    activeModal?: GlobalModalType,
    props?: GlobalModalPropsByType<T>,
  ): void;
  setModalProps<T extends GlobalModalsKeys>(
    type: T,
    props?: GlobalModalPropsByType<T>,
  ): void;
  resetActiveModal(): void;
}

const initialState: State = {
  activeModal: undefined,
  modalProps: {},
};

const useGlobalModalStore = create<State & Actions>((set, get) => ({
  ...initialState,
  setActiveModal: (activeModal, props) => {
    set({ activeModal });
    if (activeModal) {
      get().setModalProps(activeModal, {
        ...props,
        onCancel: () => {
          if (!props?.preventClose) get().setActiveModal();
          if (props?.onCancel) props.onCancel();
        },
      } as typeof props);
    }
  },
  setModalProps: (type, props) => {
    set(
      produce((state: State) => {
        state.modalProps[type] = props;
      }),
    );
  },
  resetActiveModal: () => set({ activeModal: undefined }),
}));

export default useGlobalModalStore;
